import classNames from 'classnames'

import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'
import { useSelectContext } from '../Select.hooks'
import { SelectEntityItemAvatar } from '../SelectEntityItemAvatar'

import * as styles from './SelectControlEntityValueItem.module.css'

function SelectControlEntityValueItem({
  Avatar = SelectEntityItemAvatar,
  avatarProps,
  blocked,
  className = styles.SelectControlEntityValueItem,
  disabled,
  textClassName: externalTextClassName,
  value,
  ...restProps
}) {
  const { avatar, label } = value

  const { EntityIcon } = useSelectContext()

  const { overflow: overflowText, setContentOverflowRef } = useContentOverflow()

  const textClassName = classNames(
    styles.text,
    {
      [styles.disabled]: disabled || blocked,
    },
    externalTextClassName
  )

  return (
    <div {...restProps} className={className}>
      {Avatar && (avatar || EntityIcon) ? (
        <Avatar {...avatarProps} Icon={EntityIcon} avatar={avatar} />
      ) : null}
      <FloatingTooltip content={label} disabled={!overflowText}>
        <Text className={textClassName} ref={setContentOverflowRef}>
          {label}
        </Text>
      </FloatingTooltip>
    </div>
  )
}

export default SelectControlEntityValueItem
